import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as _ from 'lodash';
import { AmChart, AmChartsService } from '@amcharts/amcharts3-angular';

import { StorageUtil } from '../../store';
import { MyTeamsService, MyProfileDashboardService } from '../../services';

@Component({
  selector: 'app-team-health-programs',
  templateUrl: './team-health-programs.component.html',
  styleUrls: ['./team-health-programs.component.css']
})
export class TeamHealthProgramsComponent implements OnInit {

  links = [{ url: null, title: 'Dashboard' }];

  teamPlayerInjuryStatusChart: any = [];
  private pieChart: AmChart;

  public playerMoodList: any = [];
  public healthStats: any;
  public mostCommonInjuries: any;

  itemsPerPage = 10;
  p = 1;

  constructor(
    public _myTeamsService: MyTeamsService,
    private _serviceTeam: MyProfileDashboardService,
    private loader: Ng4LoadingSpinnerService,
    private chartService: AmChartsService,
  ) { }

  ngOnInit() {
    this.loader.show();
    this.getHealthAndFitnessDashboardData();
  }
  getHealthAndFitnessDashboardData() {
    setTimeout(() => {
      this._serviceTeam.getTeamHealthAndFitnessDashboardData(StorageUtil.teamId).subscribe((rs: any) => {
        this.loader.hide();
        if (rs) {
          this.healthStats = rs.data.healthStats;
          console.log(this.healthStats);
          this.mostCommonInjuries = rs.data.mostCommonInjuries;
          this.teamPlayerInjuryStatusChart = rs.data.teamPlayerInjuryStatusChart;
          this.updatePieChart(this.teamPlayerInjuryStatusChart);
          this.playerMoodList = rs.data.teamPlayerMoodGrid;
        }
      }, (error) => {
        console.log(error.error);
        this.loader.hide();
      });
    }, 1500);
  }

  loadPieGraph(teamPlayerInjuryStatusChart) {
    let colors: any[] = [];
    let teamPlayerInjuryStatusChartData: any[] = []
    if (teamPlayerInjuryStatusChart.length > 0 && teamPlayerInjuryStatusChart != null) {
      _.map(teamPlayerInjuryStatusChart, function (value: any, key) {
        if (value.totalPlayersPercentage != "0") {
          if (value.injuryStatusID == 1) {
            colors.push("#6E8D8C");
          } else if (value.injuryStatusID == 2) {
            colors.push("#9F9FA0")
          } else if (value.injuryStatusID == 3) {
            colors.push("#9DDBD5")
          } else if (value.injuryStatusID == 4) {
            colors.push("#72ABD1")
          }
          teamPlayerInjuryStatusChartData.push(value)
        }
      });
    }
    if (colors.length > 0) {
      return {
        "type": "pie",
        "theme": "none",
        "dataProvider": teamPlayerInjuryStatusChartData,
        "colors": colors,
        "titleField": "injuryDescription",
        "valueField": "totalPlayersPercentage",
        "labelRadius": 2,
        "legend": {
          "position": "right",
          "marginRight": 100,
          "autoMargins": false,
          "valueText": "",
        },
        "radius": "40%",
        // "innerRadius": "20%",
        "labelText": "[[title]]",
        "labelsEnabled": false,
        "export": {
          "enabled": true
        }
      }
    }
  }

  updatePieChart(teamPlayerInjuryStatusChart) {
    this.pieChart = this.chartService.makeChart("players-injuries-status", this.loadPieGraph(teamPlayerInjuryStatusChart));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/team-health-programs/team-health-programs.component.ts